module.exports = __webpack_public_path__ + "static/media/copy-text.075d3118.svg";